import React from 'react'

import Button from 'components/Form/Button'
import { InputRaw } from 'components/Form/Input'
import Select from 'components/Form/Select'
import { Actions, Count, Field, Fields, Filters } from './styled'

export default function MarketFilters({
  activeTab, competitorOptions, filters, formatCount, onFilterChange, onQueryChange,
  onReset, pagination, periodOptions, platformOptions, query, typeOptions, t,
}) {
  return (
    <Filters onSubmit={event => event.preventDefault()}>
      <Fields>
        <Field>
          <Select
            large
            id="competitive-intelligence-market-competitor"
            placeholder={t('competitive_intelligence_research_competitor')}
            value={filters.competitor || 'all'}
            options={competitorOptions}
            onChange={value => onFilterChange('competitor', value === 'all' ? '' : value)}
          />
        </Field>
        <Field>
          <Select
            large
            id="competitive-intelligence-market-period"
            placeholder={t('competitive_intelligence_research_period')}
            value={filters.period}
            options={periodOptions}
            onChange={value => onFilterChange('period', value)}
          />
        </Field>
        {activeTab === 'social' ? (
          <Field>
            <Select
              large
              id="competitive-intelligence-market-platform"
              placeholder={t('competitive_intelligence_market_platform')}
              value={filters.platform || 'all'}
              options={platformOptions}
              onChange={value => onFilterChange('platform', value === 'all' ? '' : value)}
            />
          </Field>
        ) : activeTab === 'news' && typeOptions.length > 1 ? (
          <Field>
            <Select
              large
              id="competitive-intelligence-market-type"
              placeholder={t('competitive_intelligence_market_type')}
              value={filters.type || 'all'}
              options={typeOptions}
              onChange={value => onFilterChange('type', value === 'all' ? '' : value)}
            />
          </Field>
        ) : null}
        <Field search>
          <InputRaw
            holder
            id="competitive-intelligence-market-search"
            type="search"
            placeholder={t(`competitive_intelligence_market_search_${activeTab}`)}
            value={query}
            onChange={event => onQueryChange(event.target.value)}
          />
        </Field>
        <Actions>
          <Count>{formatCount(pagination.total)} {t(`competitive_intelligence_market_count_${activeTab}`)}</Count>
          <Button color="blue" link nospace onClick={onReset}>{t('competitive_intelligence_research_clear_filters')}</Button>
        </Actions>
      </Fields>
    </Filters>
  )
}
